export default "__VITE_ASSET__DoyAhA55__"